<template>
  <div class="input-tab-list-item">
    <input
      :id="id"
      class="input-tab-list-item__input"
      :class="{ 'input-tab-list-item__input--is-disabled': disabled }"
      type="radio"
      :name="context.name"
      :value="value"
      :required="required ? 'true' : undefined"
      :aria-required="required ? 'true' : undefined"
      :disabled="disabled"
      :checked="checked"
      @change="onChange"
    />
    <label class="input-tab-list-item__label" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  inject: ['context', 'onOptionChange'],
  props: {
    value: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked() {
      return this.context.internalValue === this.value;
    },
    id() {
      return `${this.context.id}-${this.value}`;
    },
  },
  methods: {
    onChange() {
      this.onOptionChange(this.value);
    },
  },
};
</script>
